<script lang="ts">
    import { _ } from 'svelte-i18n';
    import Select from './Select.svelte';
    import { z } from 'zod';
    import ErrorBounduary from '../components/Jobs/ErrorBounduary.svelte';

    export let hour: string = '';
    export let onChange: (selected: string) => boolean = () => true;
    export let disabled: boolean = false;
    export let canBeEmpty: boolean = false;
    export let withBorder: boolean = true;
    export let valid: boolean = true;
    export let styleMode: 'bordered' | 'non-bordered' | 'underline' = withBorder
        ? 'bordered'
        : 'non-bordered';

    let options: { id: string; label: string }[] = [];

    function getHoursAndMinutesEveryHalfHour() {
        const hours = [];
        const minutes = ['00', '30'];
        for (let i = 0; i < 24; i++) {
            for (let j = 0; j < minutes.length; j++) {
                let h = i < 10 ? `0${i}` : `${i}`;
                // // remove leading zero in h variable if unnecessary ex. 00 -> 0, 05 -> 5
                // h = h.replace(/^0+/, '');
                // if (h == '') {
                //     h = '0';
                // }
                hours.push(`${h}:${minutes[j]}`);
            }
        }
        return hours;
    }

    options = getHoursAndMinutesEveryHalfHour().map(t => ({ id: t, label: t }));
    if (canBeEmpty) {
        options.unshift({ id: '', label: $_('hour_option_not_set') });
    }

    try {
        hour = z
            .string()
            .regex(/^([01]?[0-9]|2[0-3]):[0-5][0-9]$/)
            .parse(hour);
        // remove leading zero 00:00 -> 0:00
        // hour = hour.replace(/^0+/, '');
        // if (hour == '') {
        //     hour = '0';
        // }
    } catch (e) {
        console.warn('hour not valid', hour);
        hour = '';
    }

    // if hour not exists in options add it as first item
    if (!options.find(o => o.id === hour)) {
        options.unshift({ id: hour, label: hour });
    }
</script>

<ErrorBounduary {valid}>
    <Select items={options} bind:selected={hour} {onChange} {disabled} width="100px" {styleMode} />
</ErrorBounduary>
